import { SummaryComponent } from "./MobileBookingSummary";
import {
  ChildWrapperComponent,
  ListComponent,
  ListItemComponent,
} from "./MobileBookingSummary.helpers";

const MobileBookingSummary = {
  Summary: SummaryComponent,
  ChildWrapper: ChildWrapperComponent,
  List: ListComponent,
  ListItem: ListItemComponent,
};

export { MobileBookingSummary };
